<template>
  <div>
    <ImpresaEdileBP></ImpresaEdileBP>
    <br>
    <br>
    <Servizi></Servizi>
    <Lavori></Lavori>
    <div v-if="!$isMobile()">
      <div class="qualita-container">
        <Qualita class="component-class"></Qualita>
        <div class="qualita-image"></div>
      </div>
    </div>
    <div v-else>
      <QualitaMobile></QualitaMobile>
    </div>
    <div v-if="!$isMobile()">
      <Storia></Storia>
    </div>
    <Contatti></Contatti>
    <Footer></Footer>
  </div>
</template>

<script>
import ImpresaEdileBP from '../components/ImpresaEdileBP.vue';
import Servizi from '../components/Servizi.vue';
import Lavori from '../components/Lavori.vue';
import Storia from '../components/Storia.vue';
import Qualita from '../components/Qualita.vue';
import QualitaMobile from '../components/QualitaMobile.vue';
import Contatti from '../components/Contatti.vue';
import Footer from '../components/Footer.vue';

export default {
  name: 'Home',
  components: {
    ImpresaEdileBP,
    Servizi,
    Lavori,
    Storia,
    Qualita,
    QualitaMobile,
    Contatti,
    Footer
  }
}
</script>

<style scoped>
.qualita-container {
  position: relative; 
  z-index: 1; 
  width: 100vw; 
  height: 80vh; 
  background: linear-gradient(to bottom, white, #e8f1fa); 
  display: flex; 
  flex-direction: column;
  justify-content: center; 
  align-items: center; 
}

.Qualita {
  position: relative; 
  z-index: 2; 
}

.qualita-image {
  background-image: url('../assets/quality.png'); 
  background-repeat: repeat-x; 
  background-size: contain;
  background-position: center;
  width: 100%; 
  height: 50vw; 
}

</style>
